import SearchIcon from '../Icons/menu-volia/search';
import HomeIcon from '../Icons/menu-volia/home';
import LiveTVIcon from '../Icons/menu-volia/livetv';
import FootballIcon from '../Icons/menu-volia/football';
import MoviesIcon from '../Icons/menu-volia/movies';
import SeriesIcon from '../Icons/menu-volia/series';
import KidsIcon from '../Icons/menu-volia/kids';
import RadioIcon from '../Icons/menu-volia/radio';
import FiltersIcon from '../Icons/menu-volia/filters';
import WatchHistoryIcon from '../Icons/menu-volia/history';
import WatchlistIcon from '../Icons/menu-volia/watchlist';
import ProfileIcon from '../Icons/menu-volia/profile';
import PurchasesIcon from '../Icons/menu-volia/purchases';

//добавить пункт меню Видео

export default {
  SEARCH: SearchIcon,
  HOME: HomeIcon,
  LIVE_TV: LiveTVIcon,
  SPORT: FootballIcon,
  MOVIES: MoviesIcon,
  VOD: MoviesIcon,
  TV_SERIES: SeriesIcon,
  KIDS: KidsIcon,
  RADIO: RadioIcon,
  PURCHASES: PurchasesIcon,
  CONTINUE_WATCHING: WatchHistoryIcon,
  MY_WATCHLIST: WatchlistIcon,
  PROFILE: ProfileIcon,
  FILTERS: FiltersIcon,
};
